export const validateEmail = (email: string) => {
  const pattern =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return pattern.test(String(email).toLowerCase())
}

export const validateUrl = (url: string) => {
  const pattern = new RegExp(
    "^(https?:\\/\\/)?" +
      "(([\\da-z.-]+)\\.([a-z.]{2,6})|" +
      "([\\d.]+))" +
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" +
      "(\\?[;&a-z\\d%_.~+=-]*)?" +
      "(\\#[-a-z\\d_]*)?$",
    "i",
  )
  return pattern.test(url)
}

export const validatePhone = (phone: string) => {
  return phone.replace(/\D/g, "").length === 10
}
